export enum ContactUsSubmissionsActionTypes {
    API_RESPONSE_SUCCESS = '@@contactUsSubmissions/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@contactUsSubmissions/API_RESPONSE_ERROR',
    CONTACT_US_SUBMISSIONS_LIST = '@@contactUsSubmissions/CONTACT_US_SUBMISSIONS_LIST',
}